import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PATHNAME_EXIT } from '../common/constants';
import { useDispatch } from 'react-redux';
import { setError } from '../store/actions';

const useGoBack = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [pathname, setPathname] = useState(history.location.pathname);
  const [isExitPopup, setIsExitPopup] = useState(false);

  useEffect(() => {
    const listener = history.listen((location, action) => {
      setPathname(location.pathname);

      if (action === 'POP') {
        dispatch(setError(''));

        if (PATHNAME_EXIT.includes(pathname)) {
          history.push(pathname);
          setIsExitPopup(!isExitPopup);
        }
      }
    });

    return () => {
      listener();
    };
  }, [history, pathname]);

  return [isExitPopup, setIsExitPopup];
};

export default useGoBack;
